import { RootState } from '../../store/store';
import { ROUTE_KEY, RouteState } from './slice';

export const getRouteState = (state: RootState) =>
    state[ROUTE_KEY] as RouteState;
